import { defineComponent as _defineComponent } from 'vue'
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import CountryList from '@/features/buybox/components/CountryList.vue';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySwitcherModal',
  props: {
    countrySelectedCallback: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	countrySelectedCallback?: (() => void) | null;
	additionalContexts?: SnowplowContext[];
};

const { t } = useI18n();



const modalTitle = t('WEBAPP_ACCOUNTMODAL_MAIN_COUNTRY');

async function closeSelf() {
	const { modalController } = await import('@/ionic.loader');
	props.countrySelectedCallback?.();
	modalController.dismiss();
}

return { __sfc: true,t, props, modalTitle, closeSelf, BaseModal, CountryList }
}

})